/**
 * @generated SignedSource<<9e243ea7649132f4813e007aff79b6f6>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type LoginChooseRoleInput = {
  clientMutationId?: string | null | undefined;
  roleId: string;
};
export type ChooseRoleLoginMutation$variables = {
  input: LoginChooseRoleInput;
};
export type ChooseRoleLoginMutation$data = {
  readonly loginChooseRole: {
    readonly errors: ReadonlyArray<{
      readonly messages: ReadonlyArray<string>;
      readonly path: string;
    }>;
    readonly redirectPath: string | null | undefined;
  };
};
export type ChooseRoleLoginMutation = {
  response: ChooseRoleLoginMutation$data;
  variables: ChooseRoleLoginMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "redirectPath",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "path",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "messages",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ChooseRoleLoginMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "LoginChooseRolePayload",
        "kind": "LinkedField",
        "name": "loginChooseRole",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Error",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/),
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "ChooseRoleLoginMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "LoginChooseRolePayload",
        "kind": "LinkedField",
        "name": "loginChooseRole",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Error",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c4e2ed5850731469e1705cb2b2b4dfbf",
    "id": null,
    "metadata": {},
    "name": "ChooseRoleLoginMutation",
    "operationKind": "mutation",
    "text": "mutation ChooseRoleLoginMutation(\n  $input: LoginChooseRoleInput!\n) {\n  loginChooseRole(input: $input) {\n    redirectPath\n    errors {\n      path\n      messages\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "bf96bbb786ddf3662811cde80b22e280";

export default node;
